// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"56a21576","452":"e94b6dcc","453":"7af22df3","478":"d7ceec59","509":"d1ec2e1f","587":"6adc8b8d","607":"2cefafad","702":"bea19492","874":"ce96ce85"}[chunkId] + ".chunk.js";
};